import { MutationOptions } from '../types/utils/mutation-options';
import { AxiosError } from 'axios';
import { ApiError, ApiResponse } from '../types/utils/api-response';
import { useMutation } from '@tanstack/react-query';
import { api } from '../constants/api';

export type GenerateApiKeyResponseType = {api_key: string};

export const useGenerateApiKey = (
  options?: MutationOptions<
    GenerateApiKeyResponseType,
    void,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async () => {
      const { data } = await api.post<ApiResponse<GenerateApiKeyResponseType>>(
        `/configuration/generate-key`,
        {}
      );

      return data.data;
    },

    ...options,
  });
